import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Production domain used for canonical URLs; falls back to the current origin.
const SITE_URL = (
  process.env.REACT_APP_SITE_URL || window.location.origin
).replace(/\/+$/, "");

// Adds a self-referencing <link rel="canonical"> for whichever route is active,
// so every page (including ones added later) gets one automatically.
// Query strings and hashes are dropped so variants point to the same URL.
const Canonical = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", SITE_URL + path);
  }, [pathname]);

  return null;
};

export default Canonical;
